export default {
  init() {
    // JavaScript to be fired on all pages
    let header = document.querySelector('.c-application-header');
    let navigation = document.querySelector('.c-application-header__navigation');

    document
      .querySelector('.c-application-header__toggle')
      .addEventListener('click', function() {
        header.classList.add('c-application-header--is-open');
        navigation.classList.add('c-application-header__navigation--is-open');
      });

    document
      .querySelector('.c-application-header__close')
      .addEventListener('click', function() {
        header.classList.remove('c-application-header--is-open');
        navigation.classList.remove('c-application-header__navigation--is-open');
      });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js